/* eslint-disable */
jQuery(function () {
    var onboarding = $('.onboarding-3d-building, .house-details-3d-building');
    if (onboarding.length < 1) {
        return;
    }
    var FLOOR_HEIGHT = 2.7;
    var HALFFLOOR_HEIGHT = 1;
    var ROOFS = ['Tak_Sadeltak', 'Tak_Mansardtak', 'Tak_ValmatTak', 'Tak_Pulpettak'];
    var ROOF_MATERIALS = ['pannor', 'plat', 'papp', 'eternit'];
    var FOUNDATIONS = ['Grund_Kallare', 'Grund_Platta', 'Grund_Krypgrund', 'Grund_Sutterang'];
    // Roof combinations that are not supported by the model. We could perform validation,
    // which might be confusing to the user (and potentially prevent a valid edge-case)
    // so we'll just try to render the next-best usable combination.
    //
    // Duplicated in Models/DomainModels/House3DModel.cs
    var ROOF_SUBSTITUTIONS = {
        'Tak_Sadeltak_papp': 'Tak_Sadeltak_plat',
        'Tak_Mansardtak_papp': 'Tak_Mansardtak_plat',
        'Tak_ValmatTak_papp': 'Tak_ValmatTak_plat',
        'Tak_Pulpettak_pannor': 'Tak_Pulpettak_papp',
        'Tak_Pulpettak_eternit': 'Tak_Pulpettak_papp'
    };
    var FACADE_SUBSTITUTIONS = {
        'Eternit': 'WallMat_Eternit',
        'Plaster': 'WallMat_Plaster',
        'Brick': 'WalMatl_Tegel',
        'Wood': 'WallMat_Wood'
    };
    var renderedBuilding = null;
    var roofHeight = 3.7;
    var floorHeight = 2.7;
    var roofModel = 'Tak_Sadeltak';
    var roofMaterial = 'pannor';
    $('.onboarding-3d-building, .house-details-3d-building').css({ 'opacity': '1' });
    init3DImage();
    function init3DImage() {
        $('#3d-building').addClass('no-3d-model-support');
        var foundation = $('[data-3d-model=\'foundation\']:checked').attr('data-3d-name');
        var floorCount = parseInt($('[data-3d-model=\'floor-count\']:checked').val().toString());
        var isHalfFloor = $('[data-3d-model=\'floor-count\']:checked').val() && $('[data-3d-model=\'floor-count\']:checked').val().toString().length > 1 && $('[data-3d-model=\'roof-type\']:checked').attr('data-3d-name') === 'Tak_Sadeltak';
        var roofType = $('[data-3d-model=\'roof-type\']:checked').attr('data-3d-name');
        var roofMaterial = $('[data-3d-model=\'roof-material\']:checked').attr('data-3d-name');
        var facadeMaterial = $('[data-3d-model=\'facade-material\']:checked').attr('data-3d-name');
        var roof = getRoofModel(roofType, roofMaterial);
        var facade = getFacadeMaterial(facadeMaterial);
        append3DImage(foundation, roof, facade, floorCount, isHalfFloor);
        $(document.body).on('change', '[data-3d-model=\'foundation\']', function (event) {
            foundation = event.target.getAttribute('data-3d-name') || '';
            append3DImage(foundation, roof, facade, floorCount, isHalfFloor);
        });
        $(document.body).on('change', '[data-3d-model=\'floor-count\']', function (event) {
            floorCount = parseInt($(event.target).val().toString());
            isHalfFloor = $('[data-3d-model=\'floor-count\']:checked') && $('[data-3d-model=\'floor-count\']:checked').val().toString().length > 1 && $('[data-3d-model=\'roof-type\']:checked').attr('data-3d-name') === 'Tak_Sadeltak';
            append3DImage(foundation, roof, facade, floorCount, isHalfFloor);
        });
        $(document.body).on('change', '[data-3d-model=\'roof-type\']', function (event) {
            roofType = event.target.getAttribute('data-3d-name') || '';
            roof = getRoofModel(roofType, roofMaterial);
            isHalfFloor = $('[data-3d-model=\'floor-count\']:checked').val() && $('[data-3d-model=\'floor-count\']:checked').val().toString().length > 1 && $('[data-3d-model=\'roof-type\']:checked').attr('data-3d-name') === 'Tak_Sadeltak';
            append3DImage(foundation, roof, facade, floorCount, isHalfFloor);
        });
        $(document.body).on('change', '[data-3d-model=\'roof-material\']', function (event) {
            roofMaterial = event.target.getAttribute('data-3d-name') || '';
            roof = getRoofModel(roofType, roofMaterial);
            append3DImage(foundation, roof, facade, floorCount, isHalfFloor);
        });
        $(document.body).on('change', '[data-3d-model=\'facade-material\']', function (event) {
            facadeMaterial = event.target.getAttribute('data-3d-name') || '';
            facade = getFacadeMaterial(facadeMaterial);
            append3DImage(foundation, roof, facade, floorCount, isHalfFloor);
        });
    }
    function append3DImage(foundation, roof, facade, floorCount, isHalfFloor) {
        var IMAGE_CONTAINER = $('#3d-building');
        var IMAGE = IMAGE_CONTAINER.find('#3d-image');
        if (IMAGE.length > 0) {
            IMAGE.remove();
        }
        IMAGE_CONTAINER.append('<img src="/3d-building/images/' + foundation + '.' + roof + '.' + facade + '.' + floorCount + 'f.' + (isHalfFloor ? 'HalfFloor' : '') + '.jpg" alt="" id="3d-image" class="my-house-preview-image">');
    }
    $(document).on('3d-building-loaded', function () {
        var foundation = $('[data-3d-model=\'foundation\']:checked').attr('data-3d-name');
        setFoundationModel(foundation);
        var floorCount = $('[data-3d-model=\'floor-count\']:checked').val();
        setFloorCount(floorCount, $('[data-3d-model=\'roof-type\']:checked').attr('data-3d-name'));
        var roofType = $('[data-3d-model=\'roof-type\']:checked').attr('data-3d-name');
        setRoofModel(roofType, parseInt($('[data-3d-model=\'floor-count\']:checked').val().toString()));
        var roofMaterial = $('[data-3d-model=\'roof-material\']:checked').attr('data-3d-name');
        setRoofMaterial(roofMaterial);
        var facadeMaterial = $('[data-3d-model=\'facade-material\']:checked').attr('data-3d-name');
        setFacadeMaterial(facadeMaterial);
        $('.onboarding-3d-building, .house-details-3d-building').animate({ 'opacity': '1' }, 1000);
        $(document.body).on('change', '[data-3d-model=\'foundation\']', function (event) {
            var type = event.target.getAttribute('data-3d-name') || '';
            setFoundationModel(type);
        });
        $(document.body).on('change', '[data-3d-model=\'floor-count\']', function (event) {
            var floorCount = $(event.target).val();
            setFloorCount(floorCount, $('[data-3d-model=\'roof-type\']:checked').attr('data-3d-name'));
        });
        $(document.body).on('change', '[data-3d-model=\'roof-type\']', function (event) {
            var type = event.target.getAttribute('data-3d-name') || '';
            setRoofModel(type, parseInt($('[data-3d-model=\'floor-count\']:checked').val().toString()));
        });
        $(document.body).on('change', '[data-3d-model=\'roof-material\']', function (event) {
            var material = event.target.getAttribute('data-3d-name') || '';
            setRoofMaterial(material);
        });
        $(document.body).on('change', '[data-3d-model=\'facade-material\']', function (event) {
            var material = event.target.getAttribute('data-3d-name') || '';
            setFacadeMaterial(material);
        });
    });
    function setFoundationModel(newModel) {
        FOUNDATIONS.forEach(function (foundation) { return deactivate(foundation); });
        activate(newModel);
    }
    function setFloorCount(floorCount, roofModel) {
        if ((floorCount === 2 && roofModel === 'Tak_Sadeltak') || (floorCount >= 2 && roofModel !== 'Tak_Sadeltak')) {
            activate('SecondFloor');
            deactivate('HalfFloor');
            if (roofModel === 'Tak_Sadeltak') {
                activate('Tak_Sadeltak_filler');
            }
            deactivate('Tak_Sadeltak_fonster');
            renderedBuilding.SendMessage('ScriptObject', 'MoveRoof', FLOOR_HEIGHT - roofHeight);
            roofHeight = FLOOR_HEIGHT;
        }
        else if (floorCount === 1.5 && roofModel === 'Tak_Sadeltak') {
            deactivate('SecondFloor');
            activate('HalfFloor');
            activate('Tak_Sadeltak_fonster');
            deactivate('Tak_Sadeltak_filler');
            renderedBuilding.SendMessage('ScriptObject', 'MoveRoof', HALFFLOOR_HEIGHT - roofHeight); //1
            renderedBuilding.SendMessage('ScriptObject', 'MoveHalfFloor', 0 - floorHeight); //
            floorHeight = 0;
            roofHeight = HALFFLOOR_HEIGHT;
        }
        else if (floorCount === 2.5 && roofModel === 'Tak_Sadeltak') {
            activate('SecondFloor');
            activate('HalfFloor');
            activate('Tak_Sadeltak_fonster');
            deactivate('Tak_Sadeltak_filler');
            renderedBuilding.SendMessage('ScriptObject', 'MoveRoof', FLOOR_HEIGHT + HALFFLOOR_HEIGHT - roofHeight); //3.7
            renderedBuilding.SendMessage('ScriptObject', 'MoveHalfFloor', FLOOR_HEIGHT - floorHeight); //2.7
            floorHeight = FLOOR_HEIGHT;
            roofHeight = FLOOR_HEIGHT + HALFFLOOR_HEIGHT;
        }
        else {
            deactivate('SecondFloor');
            deactivate('HalfFloor');
            if (roofModel === 'Tak_Sadeltak') {
                activate('Tak_Sadeltak_filler');
            }
            deactivate('Tak_Sadeltak_fonster');
            renderedBuilding.SendMessage('ScriptObject', 'MoveRoof', 0 - roofHeight);
            roofHeight = 0;
        }
    }
    function setRoofModel(newModel, floorCount) {
        resetRoof();
        roofModel = newModel;
        activate(roofModel);
        activate(getRoofModel(roofModel, roofMaterial));
        if (newModel !== 'Tak_Sadeltak') {
            DeactivateHalfFloor();
            setFloorCount(floorCount, newModel);
        }
        else {
            setFloorCount(floorCount, newModel);
        }
    }
    function DeactivateHalfFloor() {
        deactivate('HalfFloor');
        deactivate('Tak_Sadeltak_filler');
        deactivate('Tak_Sadeltak_fonster');
    }
    function setRoofMaterial(newMaterial) {
        deactivate(getRoofModel(roofModel, roofMaterial));
        activate(getRoofModel(roofModel, newMaterial));
        roofMaterial = newMaterial;
    }
    function getRoofModel(shape, material) {
        var baseName = shape + "_" + material;
        if (ROOF_SUBSTITUTIONS[baseName] !== undefined) {
            return ROOF_SUBSTITUTIONS[baseName];
        }
        else {
            return baseName;
        }
    }
    function resetRoof() {
        ROOFS.forEach(function (roofType) {
            deactivate(roofType);
            ROOF_MATERIALS.forEach(function (material) {
                deactivate(roofType + "_" + material);
            });
        });
    }
    function getFacadeMaterial(material) {
        return FACADE_SUBSTITUTIONS[material];
    }
    function deactivate(model) {
        renderedBuilding.SendMessage('ScriptObject', 'Deactivate', model);
    }
    function activate(model) {
        renderedBuilding.SendMessage('ScriptObject', 'Activate', model);
    }
    function setFacadeMaterial(newMaterial) {
        renderedBuilding.SendMessage('ScriptObject', 'SetFacadeMaterial', newMaterial);
    }
});
